import Mock from 'mockjs'
// import order from './order'

// Mock.mock(/\/order\/list/, 'post', order.getList)

export default Mock
